import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=7220ec32&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=7220ec32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220ec32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7220ec32')) {
      api.createRecord('7220ec32', component.options)
    } else {
      api.reload('7220ec32', component.options)
    }
    module.hot.accept("./detailInfo.vue?vue&type=template&id=7220ec32&scoped=true", function () {
      api.rerender('7220ec32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/detailInfo.vue"
export default component.exports